<template>
  <div>
    <b-overlay :show="overlay">
      <b-card no-body class="mb-0">
        <div class="m-2">
          <!-- Table Top -->
          <b-row>
            <!-- Per Page -->
            <b-col cols="12" md="3" class="d-flex align-items-center justify-content-start mb-1 mb-md-0">
              <label>Mostrar</label>

              <v-select v-model="perPage" :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'" :options="perPageOptions"
                :clearable="false" class="per-page-selector d-inline-block mx-50" />
              <label>entradas</label>
            </b-col>

            <b-col cols="12" md="9">
              <div class="d-flex align-items-center justify-content-end filters-container">
                <b-form-select v-model="searchIdUf" class="d-inline-block mr-1"
                  :options="[{ ufid: null, uf_nome: 'Selecione uma UF' }, ...dataFromApiUfId]" value-field="ufid"
                  text-field="uf_nome" placeholder="Selecione um UF" />
                <b-form-select v-model="searchIdPais" class="d-inline-block mr-1"
                  :options="[{ paisid: null, pais_nome: 'Selecione um país' }, ...dataFromApiPaisId]"
                  value-field="paisid" text-field="pais_nome" placeholder="Selecione um Pais" />
                <b-input-group class="mr-1" style="width: 200rem;">
                  <b-form-input v-model="searchInputValue" class="d-inline-block"
                    placeholder="Pesquisar por código, nome ou zona..." @keyup.enter="handleSearch" />
                  <b-input-group-append>
                    <b-button :disabled="overlay" @click="clearSearch" variant="outline-danger">
                      <feather-icon icon="TrashIcon" />
                    </b-button>
                    <b-button :disabled="overlay" @click="handleSearch" variant="outline-primary">
                      <feather-icon icon="SearchIcon" />
                    </b-button>
                  </b-input-group-append>
                </b-input-group>
                <!--              <b-button-->
                <!--                  variant="primary"-->
                <!--                  v-b-modal.modal-add-cidade-->
                <!--                  @click="resetFormData"-->
                <!--              >-->
                <!--                <div class="d-flex" style="gap: 5px">-->
                <!--                  <iconfy icon="mdi:plus"/>-->
                <!--                  <span class="">Cidade</span>-->
                <!--                </div>-->
                <!--              </b-button>-->
              </div>
            </b-col>
          </b-row>

        </div>

        <b-table ref="refCidadeListTable" class="position-relative" :items="fetchCidade" responsive
          :fields="tableColumns" primary-key="id" :sort-by.sync="sortBy" show-empty
          empty-text="Nenhum registro encontrado" :sort-desc.sync="isSortDirDesc">
          <!-- Column: Actions -->
          <template #cell(actions)="data">
            <div>
              <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" title="Visualizar" variant="gradient-primary" class="btn-icon mr-1"
                @click="openEditModal(data.item)">
                <feather-icon icon="EyeIcon" />
              </b-button>

              <!--            <b-button-->
              <!--                variant="gradient-danger"-->
              <!--                class="btn-icon"-->
              <!--                @click="openModalDeleteCustomField(data.item)"-->
              <!--            >-->
              <!--              <feather-icon icon="TrashIcon"/>-->
              <!--            </b-button>-->
            </div>

          </template>

        </b-table>
        <div class="mx-2 mb-2">
          <b-row>
            <b-col cols="12" sm="6" class="d-flex align-items-center justify-content-center justify-content-sm-start">
              <span class="text-muted">Mostrando {{ dataMeta.from }} até {{ dataMeta.to }} de {{
                dataMeta.of
              }} entradas</span>
            </b-col>
            <!-- Pagination -->
            <b-col cols="12" sm="6" class="d-flex align-items-center justify-content-center justify-content-sm-end">
              <b-pagination v-model="currentPage" :total-rows="totalCidade" :per-page="perPage" first-number last-number
                class="mb-0 mt-1 mt-sm-0" prev-class="prev-item" next-class="next-item">
                <template #prev-text>
                  <feather-icon icon="ChevronLeftIcon" size="18" />
                </template>
                <template #next-text>
                  <feather-icon icon="ChevronRightIcon" size="18" />
                </template>
              </b-pagination>
            </b-col>
          </b-row>
        </div>
      </b-card>
    </b-overlay>

    <ModalAtt idModal="modal-att-cidade" titleModal="Visualizar Cidade" :labelBtnOk="'Fechar'" v-model="dataCidade"
      @cancel="resetFormData()" />

  </div>
</template>

<script>
import { ref } from '@vue/composition-api';
import {
  BButton,
  BCard,
  BCardBody,
  BCardImg,
  BCardSubTitle,
  BCardText,
  BCardTitle,
  BCol,
  BRow,
  BListGroup,
  BListGroupItem,
  BTable,
  VBToggle,
  VBModal,
  BMedia,
  BLink,
  BAvatar,
  VBTooltip,
} from 'bootstrap-vue';
import { avatarText } from '@core/utils/filter';
import AppCollapse from '@core/components/app-collapse/AppCollapse.vue';
import AppCollapseItem from '@core/components/app-collapse/AppCollapseItem.vue';
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue';
import axios from '@/libs/axios';
import ModalAtt from './ModalAtt.vue';
import useList from './useList';

export default {
  components: {
    ModalAtt,
    BAvatar,
    BLink,
    BMedia,
    BButton,
    BCard,
    BCardBody,
    BCardImg,
    BCardSubTitle,
    BCardText,
    BCardTitle,
    BCol,
    BRow,
    AppCollapse,
    AppCollapseItem,
    BListGroup,
    BListGroupItem,
    BTable,
  },
  directives: {
    'b-toggle': VBToggle,
    'b-modal': VBModal,
    'b-tooltip': VBTooltip,
  },
  data() {
    return {
      isDeleteModal: false,
      dataFromApiUfId: '',
      dataFromApiPaisId: '',
      deletedCustomField: {
        tipopicid: null,
        regrapiccliente: '',
        regrapicrede: '',
      },
      searchInputValue: '',
    };
  },
  mounted() {
    setTimeout(() => {
      this.fetchDataFromPais();
      this.fetchDataFromUf();
    }, 5000);
  },
  methods: {
    handleRemover(id) {
      this.removerData(id);
      this.$toast({
        component: ToastificationContent,
        props: {
          title: 'Sucesso',
          text: 'Cidade deletado com sucesso',
          icon: 'CheckIcon',
          variant: 'success',
        },
      });
      this.isDeleteModal = false;
    },
    openModalDeleteCustomField(data) {
      this.deletedCustomField = data;
      this.isDeleteModal = true;
    },
    openEditModal(data) {
      this.dataCidade = data;
      this.$bvModal.show('modal-att-cidade');
    },
    resetFormData() {
      this.deletedCustomField = {
        tipopicid: null,
        regrapiccliente: '',
        regrapicrede: '',
      };
      this.dataCidade = {
        tipopicid: null,
        regrapiccliente: '',
        regrapicrede: '',
      };
      this.isDeleteModal = false;
    },
    async fetchDataFromPais() {
      try {
        const response = await axios.get('/pais');
        this.dataFromApiPaisId = response.data.data;
      } catch (error) {
        console.error('Erro ao chamar a API:', error);
      }
    },
    async fetchDataFromUf() {
      try {
        const response = await axios.get('/uf');
        this.dataFromApiUfId = response.data.data;
      } catch (error) {
        console.error('Erro ao chamar a API:', error);
      }
    },
    handleSearch() {
      this.searchQuery = this.searchInputValue;
    },
    clearSearch() {
      this.searchQuery = '';
      this.searchInputValue = '';
    },
  },
  setup() {
    const customFields = ref([]);
    const dataCidade = ref({
      tipopicid: null,
      regrapiccliente: '',
      regrapicrede: '',
    });
    // 'VARCHAR', 'INTEGER', 'TIMESTAMP', 'BOOLEAN', 'DATETIME', 'DATE', 'ENUM_OPTIONS', 'TEXT'
    const typeOptionsCustomFields = ref([
      { label: 'Texto', value: 'VARCHAR' },
      { label: 'Númerico', value: 'INTEGER' },
      { label: 'Monetário', value: 'DECIMAL' },
      { label: 'Data', value: 'DATE' },
      { label: 'Data e hora', value: 'DATETIME' },
      { label: 'Texto Longo', value: 'TEXT' },
    ]);
    const currentTab = ref(0);
    const spanderAll = ref(false);

    const headerCustomFields = [
      { key: 'id', label: '' },
      { key: 'label', label: 'Nome' },
      { key: 'quality_rules', label: 'Regras de qualidade' },
      { key: 'actions', label: 'Ações' },
    ];
    const customFieldsOptions = [
      {
        id: '1',
        label: 'Nome',
        type: 'text',
      },
      {
        id: '1',
        label: 'Nome',
        type: 'text',
      },
      {
        id: '1',
        label: 'Nome',
        type: 'text',
      },
      {
        id: '1',
        label: 'Nome',
        type: 'text',
      },
    ];

    const planOptions = [
      { label: 'Basic', value: 'basic' },
      { label: 'Company', value: 'company' },
      { label: 'Enterprise', value: 'enterprise' },
      { label: 'Team', value: 'team' },
    ];

    const statusOptions = [
      { label: 'Pending', value: 'pending' },
      { label: 'Active', value: 'active' },
      { label: 'Inactive', value: 'inactive' },
    ];

    const {
      perPage,
      currentPage,
      totalCidade,
      dataMeta,
      perPageOptions,
      searchQuery,
      searchIdUf,
      searchIdPais,
      sortBy,
      isSortDirDesc,
      tableColumns,
      refCidadeListTable,
      fetchCidade,
      overlay,
      resolveTypeFieldText,
      resolveTypeFieldIcon,
      resolveItemStatusVariant,
      resolverDefaultValues,
      create,
      Updated,
      removerData,
    } = useList();

    return {
      // Filter
      avatarText,
      planOptions,
      statusOptions,
      headerCustomFields,
      customFieldsOptions,
      spanderAll,
      currentTab,
      searchIdUf,
      searchIdPais,
      dataCidade,
      typeOptionsCustomFields,
      customFields,
      resolveTypeFieldText,
      resolveTypeFieldIcon,
      resolveItemStatusVariant,
      resolverDefaultValues,
      perPage,
      currentPage,
      totalCidade,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      fetchCidade,
      overlay,
      tableColumns,
      refCidadeListTable,
      create,
      Updated,
      removerData,
    };
  }
  ,
};
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}

.bg-header-collapse {
  background-color: #6c757d !important;
}

@media (max-width: 767.98px) {
  .filters-container {
    flex-direction: column;
    align-items: stretch;
  }

  .filters-container > * {
    width: 100%;
    margin-bottom: 0.5rem;
  }

  .filters-container > *:last-child {
    margin-bottom: 0;
  }

  .filters-container .input-group,
  .filters-container .b-form-select {
    width: 100% !important;
  }
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select';
</style>
